import { Pipe, PipeTransform } from '@angular/core';
import { TravellerDataTranslationService } from "./traveller-data-translation.service";
import { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { TravellerXTitle } from "libraries/service/resources/booking/interfaces/get-bookings.enum";

@Pipe({
    name: 'travellerGenderIcon'
})

export class TravellerGenderIconPipe implements PipeTransform {

    constructor(private readonly travellerDataTranslationService: TravellerDataTranslationService) {
    }

    public transform(title: TravellerXTitle): IconDefinition {
        return this.travellerDataTranslationService.translateTitleInIconDefinition(title);
    }
}